import { useEffect } from 'react';
import window from 'global/window';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';

import { selectUser } from 'services/Authentication/selectors';

import { receivedAuthenticationFail } from 'services/Authentication/actions';

import { useAppDispatch } from 'hooks/store';

export default (Component) => (props) => {
  const location = useLocation();
  const history = useHistory();
  // @ts-expect-error TS(2339): Property 'pathname' does not exist on type 'unknow... Remove this comment to see the full error message
  const pathname = location.state?.pathname || '/';

  const user = useSelector(selectUser());
  const dispatch = useAppDispatch();

  const checkAuth = (isAuthenticated) => {
    if (isAuthenticated) {
      history.push(pathname);
    }
  };

  useEffect(() => {
    let authToken = null;

    try {
      authToken = window.localStorage.getItem('api_token');
    } catch {
      Sentry.addBreadcrumb({
        level: 'warning',
        category: 'browser',
        message: 'Local Storage is not available.',
      });
    }

    try {
      checkAuth(Boolean(user || authToken));
    } catch {
      dispatch(
        receivedAuthenticationFail({
          nonFieldErrors: ['Cookies are disabled. You will not be able to login.'],
        })
      );
      checkAuth(false);
    }
  }, [user]);

  return <Component {...props} />;
};
